import { APPSTATE } from '../../state'
import { getModelColor } from '../../utilities/colors'

export const MFC_NEWS_ACCOUNT = {
    id: 481462,
    username: 'MyFreeCams_News',
    access_level: 5,
    active: 1,
    verified: '1',
    avatar: 'https://img.mfcimg.com/photos2/481/481462/avatar.300x300.jpg?nc=1354656943',
}

/**
 * Check if a user is MFC News or not
 * @param user
 * @returns boolean
 */
export const isMfcNews = (user) => {
    if (user?.id === MFC_NEWS_ACCOUNT.id) return true
    return false
}

/**
 * Grabs a font value from MFC API results
 * @param apiString
 * @returns { font, color }
 */
export const getFontStyles = (apiString: string) => {
    const trimmed = apiString.indexOf('#')
    const fontStart = apiString.indexOf('font-family:')
    const fontContent = apiString.slice(
        fontStart + 'font-family:'.length,
        apiString.length - 2,
    )
    const color = apiString.slice(trimmed, 13)
    return {
        color: getModelColor(color, APPSTATE.app.darkMode),
        font: fontContent,
    }
}

export const NEWS_DEFAULT_UEOPT = 3

export const NewsOptionsMask = {
    FCNEWSOPT_IN_CHAN: 1, // 3 - 1 = 2 (toggle off)
    FCNEWSOPT_IN_PM: 2, // 3 - 2 = 1 (toggle off)
    FCNEWSOPT_ADDFRIENDS_OFF: 4, // 3 + 4 = 7 (toggle off only)
    FCNEWSOPT_IN_CHAN_NOPVT: 8, // 3 + 8 = 11  (toggle off)
    FCNEWSOPT_IN_CHAN_NOGRP: 16, // 3 + 16 = 19 (toggle off)
}

export const toggleNewsInChat = (base, remove = true): number => {
    if (remove) return base - NewsOptionsMask.FCNEWSOPT_IN_CHAN
    else return base + NewsOptionsMask.FCNEWSOPT_IN_CHAN
}

export const toggleNewsInPrivateMessages = (
    base = NEWS_DEFAULT_UEOPT,
    remove = true,
): number => {
    if (remove) return base - NewsOptionsMask.FCNEWSOPT_IN_PM
    else return base + NewsOptionsMask.FCNEWSOPT_IN_PM
}

export const toggleNewsFromFriends = (
    base = NEWS_DEFAULT_UEOPT,
    remove = true,
): number => {
    if (remove) return base + NewsOptionsMask.FCNEWSOPT_ADDFRIENDS_OFF
    else return base - NewsOptionsMask.FCNEWSOPT_ADDFRIENDS_OFF
}

export const toggleNewsInPrivateShows = (
    base = NEWS_DEFAULT_UEOPT,
    remove = true,
): number => {
    if (remove) return base + NewsOptionsMask.FCNEWSOPT_IN_CHAN_NOPVT
    else return base - NewsOptionsMask.FCNEWSOPT_IN_CHAN_NOPVT
}

export const toggleNewsInClubShows = (
    base = NEWS_DEFAULT_UEOPT,
    remove = true,
): number => {
    if (remove) return base + NewsOptionsMask.FCNEWSOPT_IN_CHAN_NOGRP
    else return base - NewsOptionsMask.FCNEWSOPT_IN_CHAN_NOGRP
}

export const calculateNewsSettings = (newsSelectionValue: number) => {
    const newsSettings = {
        FCNEWSOPT_IN_CHAN:
            NewsOptionsMask['FCNEWSOPT_IN_CHAN'] & newsSelectionValue,
        FCNEWSOPT_IN_PM:
            NewsOptionsMask['FCNEWSOPT_IN_PM'] & newsSelectionValue,
        FCNEWSOPT_ADDFRIENDS_OFF:
            NewsOptionsMask['FCNEWSOPT_ADDFRIENDS_OFF'] & newsSelectionValue &&
            1,
        FCNEWSOPT_IN_CHAN_NOPVT: !(
            NewsOptionsMask['FCNEWSOPT_IN_CHAN_NOPVT'] & newsSelectionValue
        ),
        FCNEWSOPT_IN_CHAN_NOGRP: !(
            NewsOptionsMask['FCNEWSOPT_IN_CHAN_NOGRP'] & newsSelectionValue
        ),
    }

    return newsSettings
}

export const showNewsInPrivateMessages = (code: number): boolean => code >= 2
export const showsNewsInRooms = (code: number): boolean => code >= 1
export const showNewsInClubShows = (enabled: boolean): boolean => enabled
export const showNewsInPrivateShows = (enabled: boolean): boolean => enabled
export const showNewsFromFriends = (code: number): boolean => code === 0

export const NewsDictionary = {
    FCNEWSOPT_IN_CHAN: 'Chat Rooms',
    FCNEWSOPT_IN_PM: 'Private Messages',
    FCNEWSOPT_IN_CHAN_NOPVT: 'Private Shows',
    FCNEWSOPT_IN_CHAN_NOGRP: 'Group & Club Shows',
    FCNEWSOPT_ADDFRIENDS_OFF: 'Display News from Friends',
    NEWS_IN_HEADER: 'Enable Header Notifications for news',
} as const
